import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_profile",
  "use": "svg_profile-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\" id=\"svg_profile\"><path d=\"M15.237 13.906c-1.071-1.851-2.721-3.179-4.647-3.808a5.062 5.062 0 1 0-5.18 0c-1.925.629-3.575 1.956-4.646 3.808a.562.562 0 1 0 .973.563c1.325-2.29 3.667-3.656 6.263-3.656 2.597 0 4.938 1.366 6.263 3.656a.562.562 0 1 0 .974-.563ZM4.063 5.75a3.938 3.938 0 1 1 7.875 0 3.938 3.938 0 0 1-7.875 0Z\" fill=\"#1161CA\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol